import React from "react";
import "./Banner.css";
import { NavLink } from "react-router-dom";

export default function Banner({
  bannerTitle,
  className,
  button1,
  button2,
  href1,
  href2,
}) {
  return (
    <>
      <div className={`${className} banner-main-container`}>
        <div className="container ">
          <h1>{bannerTitle}</h1>
          {button1 && (
            <NavLink to={href1}>
              <button className="banner pt-2 pb-2 px-3 rounded me-3">
                {button1}
              </button>
            </NavLink>
          )}

          {button2 && (
            <NavLink to={href2}>
              <button className="banner pt-2 pb-2 px-3 rounded mt-md-2 mt-2">
                {button2}
              </button>
            </NavLink>
          )}
        </div>
      </div>
    </>
  );
}
